import { ColorPicker } from 'antd';
import * as React from 'react';

interface FCProps {
  defaultValue: string;
  textColor?: string;
  exampleText?: React.ReactNode;
  width?: number;
  height?: number;
  onChange: (value: string) => void;
  onOpenChange?: (lastColorValue: string, open: boolean) => void;
}

const AbjustColor: React.FC<FCProps> = ({
  defaultValue,
  textColor = '#000',
  exampleText,
  width = 76,
  height = 64,
  onChange,
  onOpenChange
}) => {
  const [color, setColor] = React.useState<string>(defaultValue);
  const [open, setOpen] = React.useState(false);

  return (
    <div className="flex flex-col">
      <ColorPicker
        value={color}
        open={open}
        onChange={(value) => {
          const hex = value.toHexString();
          setColor(hex);
          onChange && onChange(hex);
        }}
        onOpenChange={(isOpen) => {
          setOpen(isOpen);
          onOpenChange && onOpenChange(color, isOpen);
        }}
      >
        <div
          onClick={() => setOpen(true)}
          style={{
            width: width,
            height: height,
            backgroundColor: color,
            color: textColor,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 'bold',
            cursor: 'pointer',
            userSelect: 'none',
            border: '1px solid rgba(0,0,0,0.06)'
          }}
        >
          {exampleText || ''}
        </div>
      </ColorPicker>
    </div>
  );
};

export default AbjustColor;
